<template>
    <!-- Password expiration time card -->
    <div class="col-xl-3 col-md-6 mb-4" :class="block" :id="id">
        <div class="card border-left-info shadow h-100 py-2">
            <div class="card-body">
                <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                        <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">{{ title }}
                        </div>
                        <div class="h5 mb-0 font-weight-bold text-gray-800">
                            <div v-if="data" :dusk="id + '_content'">
                                <span>{{ data }}</span>
                                <span v-if="suffix">{{ suffix }}</span>
                            </div>
                            <div v-else><img src="/images/ripple.60px.svg"/></div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <i class="fa-2x text-gray-300" v-bind:class="faclass"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Card',
    mounted() {
        this.axios.get(this.url).then(response => {
            this.data = response.data.data[this.field].toString();
        }).catch(error => {
            console.log(this.$shared.errorHandlerForResponder(error));
            this.data = 'n/a';
        });

    },
    data: function () {
        return {
            data: '',
            faclass: `${this.fatype} ${this.fa}`,
        };
    },
    props: {
        id: String,
        title: String,
        suffix: String,
        url: String,
        field: String,
        fa: String,
        fatype: String,
        block: {
            type: String,
            default: 'd-none d-sm-block'
        }
    }
}
</script>
